import { forwardRef, type ComponentRef, type HTMLAttributes } from 'react';

import { cn } from '~lib/utils/style';

interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {}

const Skeleton = forwardRef<ComponentRef<'div'>, SkeletonProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      aria-hidden
      className={cn(
        'animate-shine rounded-md',
        'bg-[linear-gradient(110deg,hsl(var(--color-gray-100))_8%,hsl(var(--color-gray-050))_18%,hsl(var(--color-gray-100))_33%)]',
        'bg-[length:200%_100%]',
        className,
      )}
      {...props}
    />
  ),
);
Skeleton.displayName = 'Skeleton';

export { Skeleton };
